import React from "react";
import { View, ActivityIndicator, Modal, Text, StyleSheet } from "react-native";
import colors from "@constants/color";

import t from "../constants/localization";

const PATH = "components/LoadingScreen";

const LoadingSreen = ({ onRequestClose, visible }) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={visible}
      animationType="fade"
      transparent={true}
      onRequestClose={onRequestClose}
    >
      <View style={styles.background}>
        <ActivityIndicator color={colors.primary} size="large" />
        <Text style={{ color: colors.darktext }}>
          {t(`${PATH}/processingRequest`)}
        </Text>
      </View>
    </Modal>
  );
};

export default LoadingSreen;

const styles = StyleSheet.create({
  background: {
    backgroundColor: "rgba(255,255,255, 0.7)",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
});
